import {
  CouponAreaDataTestIds,
  CouponAreaRoutes,
} from '@backoffice-frontend/common'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { CouponIcon } from '@moia-dev/pace-icons'

export const CouponAreaNavigationIcon = CouponIcon

export const CouponAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={CouponAreaRoutes.route}
      Icon={CouponIcon}
      dataTestId={CouponAreaDataTestIds.Navigation}
    />
  )
}
